exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overviewIconContainer-abfa6{display:flex;justify-content:center;margin:20px}", ""]);

// Exports
exports.locals = {
	"overviewIconContainer": "overviewIconContainer-abfa6"
};